export const ActivitiesLeasePermissions = {
  AddNewActivity: {
    permissionsId: '38219833-1792-4394-ca10-08d92ff25bf0',
    permissionsName: 'Add new activity',
    componentsId: null,
    components: null,
  },
  ViewAndSearchInLeaseActivities: {
    permissionsId: 'd04cb427-034c-4440-ca11-08d92ff25bf0',
    permissionsName: 'View and search in lease Activities',
    componentsId: null,
    components: null,
  },
  ViewActivityDetails: {
    permissionsId: '4123b547-773a-4b1c-ca12-08d92ff25bf0',
    permissionsName: 'View Activity details',
    componentsId: null,
    components: null,
  },
  EditActivity: {
    permissionsId: '72496ecd-e3aa-4a24-ca13-08d92ff25bf0',
    permissionsName: 'Edit Activity',
    componentsId: null,
    components: null,
  },
};
